module.exports = __webpack_public_path__ + "img/zodiac-hustle-congratulations.04ecca23.jpg";